export class ExternalIntegrationApiService {
	constructor(CoreApi, customerId) {
		this.CoreApi = CoreApi;
		this.customerId = customerId;
	}
	list(params) {
		return this.CoreApi.makeApiCall("POST", "webhooks-groups/as-pbx/list/", this.prepareParams(params)).then(r => r.data);
	}
	getOptions(params) {
		return this.CoreApi.makeApiCall("POST", "webhooks-groups/as-pbx/get-all-options/", this.prepareParams(params)).then(r => r.data);
	}
	create(params) {
		return this.CoreApi.makeApiCall("POST", "webhooks-groups/as-pbx/create/", this.prepareParams(params)).then(r => r.data);
	}

	prepareParams(params) {
		return {
			...params,
			customer: this.customerId
		};
	}
	// delete(numbers) {
	// 	return this.CoreApi.makeApiCall("POST", "incoming_sms/delete/", null, {numbers: JSON.stringify(numbers)}).then(r => r);
	// }
	// create(data) {
	// 	return this.CoreApi.makeApiCall("POST", "incoming_sms/save/", null, {data: JSON.stringify(data)}).then(r => r);
	// }
	// update(rows) {
	// 	return this.CoreApi.makeApiCall("POST", "incoming_sms/update/", null, {data: JSON.stringify(rows)}).then(r => r);
	// }
}
